import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet, ConnectorUser } from './';
import { ConnectorModel } from './connector.model';
import CloudflareIcon from '@/assets/connector-icons/cloudflare.svg';

export type CloudflareConfig = {
  authenticationType: 'user' | 'user-connector-fallback' | 'connector';
  orgAuthEnabled: boolean;
  xAuthenticatedUserEnabled: boolean;
  connectorId: string;
  catalogUrl?: string;
  user: ConnectorUser;
  userId: string;
};

export class CloudflareConnectorModel extends ConnectorModel {
  config: CloudflareConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'cloudflare';
    this.typeLabel = 'Cloudflare';
    this.iconSVG = CloudflareIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: false,
      ingress: true,
    };

    this.config = (data.config as CloudflareConfig) || {
      authenticationType: 'user-connector-fallback',
      orgAuthEnabled: false,
      xAuthenticatedUserEnabled: false,
      connectorId: '',
      user: undefined,
      userId: '',
    };
  }
  get hasConnectorAuthentication(): boolean {
    return ['user-connector-fallback', 'connector'].includes(this.config.authenticationType);
  }
}
